const percent = new Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 });

// Plugin local: agrega etiquetas sin cambiar las demás gráficas de la aplicación.
export const chartValueLabels = {
  id: "gerenciaValueLabels",
  afterDatasetsDraw(chart, _args, options) {
    const { ctx, chartArea } = chart;
    ctx.save();
    ctx.font = "600 11px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.fillStyle = options.color || "#344767";
    ctx.strokeStyle = options.halo || "#fff";
    ctx.lineWidth = 4;
    ctx.lineJoin = "round";
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (!chart.isDatasetVisible(datasetIndex)) return;
      chart.getDatasetMeta(datasetIndex).data.forEach((element, index) => {
        const value = dataset.data[index];
        if (!Number.isFinite(value) || element.skip) return;
        const { x, y } = element.getProps(["x", "y"], false);
        if (!Number.isFinite(x) || !Number.isFinite(y) || x < chartArea.left || x > chartArea.right)
          return;
        const text = `${percent.format(value)}%`;
        const halfWidth = ctx.measureText(text).width / 2;
        const labelX = Math.max(
          chartArea.left + halfWidth,
          Math.min(x, chartArea.right - halfWidth)
        );
        const labelY = Math.max(13, y - 8);
        ctx.strokeText(text, labelX, labelY);
        ctx.fillText(text, labelX, labelY);
      });
    });
    ctx.restore();
  },
};
